export const SECONDS = 60;
export const MILLI_SECONDS = 1000;
export const ONE_DAY_IN_MINUTES = 24 * 60;

export const queryStaleTime = (minutes = 5): number =>
  minutes * SECONDS * MILLI_SECONDS;

export const tenMinutes = queryStaleTime(10);
export const fiveMinutes = queryStaleTime(5);
export const oneDay = queryStaleTime(ONE_DAY_IN_MINUTES);
export const oneHour = queryStaleTime(60);
